module.exports = __webpack_public_path__ + "static/img/dynamicp.8ab1150.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicp.png
// module id = q90D
// module chunks = 45